import { Directive, ElementRef, HostListener } from '@angular/core';
import { assert } from '@sama/js-core';
import { setCssProperty } from './misc-utils';

/**
 * Scrolling on workspace should never scroll page, in order
 * to enable scrollable components we must add this directive.
 * data-scrollHandled attribute tells the output that this component scrolls.
 */
@Directive({
  selector: '[h3ScrollEnabler]',
})
export class ScrollEnablerDirective {
  constructor(private elementRef: ElementRef) {
    setCssProperty(elementRef, 'overscroll-behavior', 'none');
    this.elementRef.nativeElement.setAttribute('data-scrollHandled', 'true');
  }

  @HostListener('wheel', ['$event']) handleScrollEvent(event: WheelEvent) {
    if (this.isNotScrollable()) {
      isHandledByOtherDirective(
        event,
        event.target as HTMLElement,
        this.elementRef.nativeElement,
      );
    }
  }

  private isNotScrollable() {
    return (
      this.elementRef.nativeElement.scrollHeight <=
      this.elementRef.nativeElement.clientHeight
    );
  }
}

/**
 * For nested outputs we need to prevent bubbling to
 * tag editor and preventDefault() being called from there.
 *
 * @param targetElement: element that the mouse is hovering.
 * @param elementWithScrollEnabler : element with scrollable behaviour
 */
export function isHandledByOtherDirective(
  event: Event,
  targetElement: HTMLElement | null,
  elementWithScrollEnabler: HTMLElement,
): void {
  assert(targetElement, 'targetElement must not be null');

  if (targetElement.classList.contains('drawer')) {
    return handlePowerListMenu(event, targetElement);
  }

  if (
    targetElement === document.body ||
    targetElement === elementWithScrollEnabler
  ) {
    return event.preventDefault();
  }

  if (targetElement.getAttribute('data-scrollHandled')) {
    return;
  }

  return isHandledByOtherDirective(
    event,
    targetElement.parentElement,
    elementWithScrollEnabler,
  );
}

/**
 * powerlistsMenus have a maximum height predetermined via the legacy code,
 * this is added as a workaround otherwise powerlists won't scroll.
 */
function handlePowerListMenu(event: Event, drawer: HTMLElement) {
  if (drawer.clientHeight === drawer.scrollHeight) {
    event.preventDefault();
  }
}
